/**
 * Provider string on cloud account rows / selectors (AWS, Azure, GCP).
 * Matches {@link CloudAccountType} `provider` from `@labrav/react-components` (V4 CloudAccount).
 */
export type CloudAccountProvider = 'AWS' | 'AZURE' | 'GCP'

/** Lowercase cloud key passed to `useAuth().canDo({ cloud, ... })` for gatekeeper policy input. */
export type AuthPolicyCloud = 'aws' | 'azure' | 'gcp'

export const providerToAuthCloud = (
  provider: string | CloudAccountProvider
): AuthPolicyCloud => {
  const p = (provider || '').toString().toUpperCase()
  if (p.includes('AZURE')) return 'azure'
  if (p.includes('GCP')) return 'gcp'
  // Default to aws for unknown / other providers (including REDHAT)
  return 'aws'
}
